import { render, staticRenderFns } from "./DiagnoseView.vue?vue&type=template&id=ec148bc6&scoped=true"
import script from "./DiagnoseView.vue?vue&type=script&lang=js"
export * from "./DiagnoseView.vue?vue&type=script&lang=js"
import style0 from "./DiagnoseView.vue?vue&type=style&index=0&id=ec148bc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec148bc6",
  null
  
)

export default component.exports